// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_KGE","cls2":"VideoPlayerMainContent-cls2_ZPp VideoPlayerMainContent-cls1_KGE"};